/*
  Fills sections/product-recently-viewed-grid.liquid from the product ids the
  theme stores in localStorage under `_halo_recently_viewed` (written by
  product-info.js and product-left-thumbs.js).
*/
if (!customElements.get('recently-viewed-grid')) {
  const STORAGE_KEY = '_halo_recently_viewed';

  class RecentlyViewedGrid extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-rvg-list]');
      if (!this.list) return;

      this.limit = parseInt(this.dataset.limit, 10) || 5;
      this.currentProductId = parseInt(this.dataset.productId, 10) || null;
      this.productIds = this.readProductIds();

      if (!this.productIds.length) {
        this.handleEmpty();
        return;
      }

      this.load();
    }

    readProductIds() {
      let stored = [];

      try {
        stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (error) {
        // Private mode and blocked site data both throw here.
        return [];
      }

      if (!Array.isArray(stored)) return [];

      return stored
        .map(Number)
        .filter((id) => Number.isFinite(id) && id > 0 && id !== this.currentProductId)
        .slice(0, this.limit);
    }

    load() {
      const query = this.productIds.map((id) => `id:${id}`).join('%20OR%20');

      fetch(`${this.dataset.url}${query}`)
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const cards = Array.from(parsed.querySelectorAll('[data-rvg-item]'));

          if (!cards.length) {
            this.handleEmpty();
            return;
          }

          // Search returns matches by relevance, so put them back in view order.
          cards.sort(
            (a, b) =>
              this.productIds.indexOf(Number(a.dataset.productId)) -
              this.productIds.indexOf(Number(b.dataset.productId))
          );

          this.list.replaceChildren(...cards.map((card) => document.importNode(card, true)));
          this.hidden = false;
        })
        .catch(() => this.handleEmpty());
    }

    handleEmpty() {
      // Nothing viewed yet: drop the section rather than leave an empty heading.
      if (this.hasAttribute('data-keep-visible')) return;
      this.remove();
    }
  }

  customElements.define('recently-viewed-grid', RecentlyViewedGrid);
}
